import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

const CSRF_COOKIE = "__Host-tb_csrf";

function getCookie(name) {
  const prefix = `${name}=`;
  const item = document.cookie
    .split("; ")
    .find((row) => row.startsWith(prefix));

  return item ? decodeURIComponent(item.slice(prefix.length)) : null;
}

// Eski localStorage JWT'lerini migration sırasında temizle.
// Artık authentication için localStorage kullanılmıyor.
try {
  localStorage.removeItem("atlas_token");
} catch (_) {
  // localStorage erişimi engelliyse sorun değil.
}

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const method = (config.method || "get").toLowerCase();

  if (["post", "put", "patch", "delete"].includes(method)) {
    const csrf = getCookie(CSRF_COOKIE);
    if (csrf) {
      config.headers["X-CSRF-Token"] = csrf;
    }
  }

  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Bir hata oluştu. Lütfen tekrar deneyin.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function trackEvent(slug, payload) {
  try {
    axios.post(`${API}/analytics/${slug}/event`, payload);
  } catch (e) {
    // swallow
  }
}

export const PRIMARY_CATEGORIES = ["Fade", "Taper", "Kısa", "Modern / Uzun"];
export const CATEGORY_STYLES = {
  "Fade": ["Low Fade", "Mid Fade", "High Fade", "Skin Fade"],
  "Taper": ["Low Taper", "Mid Taper", "Taper Fade"],
  "Kısa": ["Buzz Cut", "French Crop", "Textured Crop"],
  "Modern / Uzun": ["Mullet", "Bro Flow"],
};
export const ALL_STYLES = Object.values(CATEGORY_STYLES).flat();
